<template>
  <div id="app" :class="set_font_style">
    <!-- <div ref="loader_wrapper" id="loader-wrapper">  :class="fontclass"
      <div id="loader"></div>
      <div class="loader-section section-left"></div>
      <div class="loader-section section-right"></div>
      <div class="load_title">正在加载XXX课题组,请稍等……</div>
    </div>-->
    <!-- style="overflow-y:scroll" -->
    <!-- <el-container>
      <el-header height="220px">
        <v-header></v-header>
        <vnav></vnav>
    </el-header>-->

    <!-- <slot name="navvv"></slot> -->
    <el-backtop :style="{'color':all_app_color}" :right="20"></el-backtop>
    <!-- <el-main width="1300px"> -->
    <router-view></router-view>
    <!-- <router-view v-if="isRload"></router-view> -->

    <!-- <slot name="slideshow"></slot>
        <slot name="homeLntroduction"></slot>
        <slot name="researchgroupdynamics"></slot>
        <slot name="joinus"></slot>
    <slot name="friendlylink"></slot>-->
    <!-- </el-main> -->

    <!-- <el-footer class="footerBottom" height="200px">
        <v-footer></v-footer>
      </el-footer>
    </el-container>-->
  </div>
</template>
<script>
// import vHeader from "@/components/page/header/header.vue";
// import vFooter from "@/components/page/footer/footer.vue";
// import vnav from "@/components/page/nav/nav.vue";
import * as ServiceApi from "./components/page/Login/api/login";
export default {
  name: "app",
  // components: {
  //   vHeader,
  //   vFooter,
  //   vnav
  // },
  watch: {
    $route(to, from) {
      if (to.name != "member") {
        document.getElementsByTagName("title")[0].innerText =
          "房传营课题组";

        let head = document.getElementsByTagName("head")[0];
        let ico;
        //创建一个<link>标签
        let linkTag = document.createElement("link");
        //配置<link>标签的相关属性
        linkTag.setAttribute("rel", "Shortcut Icon");
        linkTag.setAttribute("type", "image/x-icon");
        //根据渠道配置不同的图标以及标题文字
        // if (channel == 'TIANXIANG') {
        //更改标题文字
        // document.getElementsByTagName("title")[0].innerText = '天象';
        //配置之前创建<link>标签的引用图标路径
        ico = "../../../../static/favicon.ico";
        linkTag.href = ico;

        //添加到<head>头部中
        head.appendChild(linkTag);
      } else {
        let head = document.getElementsByTagName("head")[0];
        let ico;
        //创建一个<link>标签
        let linkTag = document.createElement("link");
        //配置<link>标签的相关属性
        linkTag.setAttribute("rel", "Shortcut Icon");
        linkTag.setAttribute("type", "image/x-icon");
        //根据渠道配置不同的图标以及标题文字
        // if (channel == 'TIANXIANG') {
        //更改标题文字
        // document.getElementsByTagName("title")[0].innerText = '天象';
        //配置之前创建<link>标签的引用图标路径
        ico = "../../../../static/favicon_1.ico";
        linkTag.href = ico;

        //添加到<head>头部中
        head.appendChild(linkTag);
      }
      let that = this;
      setTimeout(function() {
        let arr = that.$store.state.navlistdata;
        for (let i = 0; i < that.$store.state.navlistdata.length; i++) {
          if (arr[i].portal_routes == to.path) {
            that.$store.commit("isclicknavactive", i);
            return;
          }
        }
      }, 500);
      if (to !== from) {
        this.$store.commit("isfalseclickshow");
      }
      // console.log(to.name,from.name,'dynamicdetails','dynamic');
      if(to.name == 'dynamicDetails'&&from.name =='dynamic'){
        // console.log(to,from,'dynamicdetails','dynamic');
        this.$store.commit('to_dynamicdetails_from_dynamic_change',true);
      }else{
        this.$store.commit('to_dynamicdetails_from_dynamic_change',false);
      }
      // console.log(to);
      // console.log(from);
    }
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      all_app_color: "#3b9dce",
      isRload: true,
      // fontclass: ""
      set_font_style: ""
    };
  },
  methods: {
    get_color_style() {
      let that = this;
      ServiceApi.get_get_font_style({
        type: "font_color_model"
      }).then(body => {
        // console.log(body);
        if (body.data.label == "ZTYSMB001") {
          document.documentElement.style.setProperty(
            "--set_font_colorS",
            "#999999"
          );
        } else if (body.data.label == "ZTYSMB002") {
          document.documentElement.style.setProperty(
            "--set_font_colorS",
            "#666666"
          );
        } else if (body.data.label == "ZTYSMB003") {
          document.documentElement.style.setProperty(
            "--set_font_colorS",
            "#000000"
          );
        } 
      });
    },
    get_font_size_style() {
      let that = this;
      ServiceApi.get_get_font_style({
        type: "font_size_model"
      }).then(body => {
        // console.log(body);
        if (body.data.label == "ZTDXMB001") {
          document.documentElement.style.setProperty(
            "--set_font_sizeS",
            "16px"
          );
        } else if (body.data.label == "ZTDXMB002") {
          document.documentElement.style.setProperty(
            "--set_font_sizeS",
            "18px"
          );
        } else if (body.data.label == "ZTDXMB003") {
          document.documentElement.style.setProperty(
            "--set_font_sizeS",
            "20px"
          );
        } 
      });
    },
    get_font_style() {
      let that = this;
      ServiceApi.get_get_font_style({
        type: "font_model"
      }).then(body => {
        // console.log(body);
        if (body.data.label == "ZTMB00001") {
          // 宋体
          this.set_font_style = "songti";
        } else if (body.data.label == "ZTMB00002") {
          // 微软雅黑
          this.set_font_style = "microsoft_yahei";
        } else if (body.data.label == "ZTMB00003") {
          //  华文细黑
          this.set_font_style = "huawenxihei";
        } else if (body.data.label == "ZTMB00004") {
          //  黑体
          this.set_font_style = "heiti";
        } else if (body.data.label == "ZTMB00005") {
          //
          this.set_font_style = "Noto_Serif";
        } else if (body.data.label == "ZTMB00006") {
          //
          this.set_font_style = "Comic_Sans_MS";
        } else if (body.data.label == "ZTMB00007") {
          //
          this.set_font_style = "Helvetica";
        } else if (body.data.label == "ZTMB00008") {
          //
          this.set_font_style = "Arial";
        } else if (body.data.label == "ZTMB00009") {
          //
          this.set_font_style = "Lucida";
        } else if (body.data.label == "ZTMB00010") {
          //
          this.set_font_style = "Verdana";
        } else if (body.data.label == "ZTMB00011") {
          //
          this.set_font_style = "Lucida_Grande";
        }
      });
    },
    // get_font_style() {
    //   let that = this;
    //   ServiceApi.get_get_font_style({
    //     type: "font_model"
    //   }).then(body => {
    //     console.log(body);
    //     if (body.data.label == "ZTMB00001") {
    //       // 德彪钢笔行书
    //       $youziku.load(
    //         "body",
    //         "e1ccb2a5a25448699c382b345a7e4c5b",
    //         "LiDeBiao-Xing3"
    //       );

    //       $youziku.draw();
    //     } else if (body.data.label == "ZTMB00002") {
    //       // 思源黑体Light
    //       $youziku.load(
    //         "body",
    //         "63d1baa410724025979a91aee5500d08",
    //         "Source-Han-Light"
    //       );
    //       $youziku.draw();
    //     } else if (body.data.label == "ZTMB00003") {
    //       // 思源黑体Normal
    //       $youziku.load(
    //         "body",
    //         "d2be3504e19c4cceb526eb07782acdae",
    //         "Source-Han-Normal"
    //       );
    //       $youziku.draw();
    //     } else if (body.data.label == "ZTMB00004") {
    //       //  思源黑体ExtraLight
    //       $youziku.load(
    //         "body",
    //         "48677cae8ee0491ab61bd30b120165bf",
    //         "SiYuan-ExtraLight"
    //       );
    //       $youziku.draw();
    //     } else if (body.data.label == "ZTMB00005") {
    //       //  思源黑体Regular
    //       $youziku.load(
    //         "body",
    //         "501804eb41c74258bcfbb3f36d1df3e1",
    //         "SiYuanRegular"
    //       );
    //       $youziku.draw();
    //     } else if (body.data.label == "ZTMB00006") {
    //       // 经典中圆简
    //       $youziku.load(
    //         "body",
    //         "f7e79a809e5d4ab88ed5e1772a032123",
    //         "jdzhonyuanjian"
    //       );
    //       $youziku.draw();
    //     } else if (body.data.label == "ZTMB00007") {
    //       // 田氏宋体旧字形
    //       $youziku.load("body", "0791a9ccb8cc48e49013cab24abd73c2", "TSSunOld");
    //       $youziku.draw();
    //     } else if (body.data.label == "ZTMB00008") {
    //       //默认字体
    //     } else if (body.data.label == "ZTMB00009") {
    //       // 幼圆
    //       $youziku.load("body", "72d9bc68a25f4fc8bc2c7d47a40fe65c", "YouYuan");
    //       $youziku.draw();
    //     } else if (body.data.label == "ZTMB00010") {
    //       // 创艺简行楷
    //       $youziku.load("body", "dbdd9724ec9b479f8ae49c3d1d6b1375", "cyjianxk");
    //       $youziku.draw();
    //     }

    //     // 创艺简行楷
    //     //  $youziku.load("body", "dbdd9724ec9b479f8ae49c3d1d6b1375", "cyjianxk");
    //     // $youziku.draw();
    //     // that.$store.commit("change_EnglishUrl", body.data.content);
    //     // localStorage.setItem("EnglishUrl", body.data.content);
    //   });
    // },
    get_by_id_lang_link() {
      let that = this;
      ServiceApi.get_by_id_lang_link({}).then(body => {
        // console.log(body);
        that.$store.commit("change_EnglishUrl", body.data.content);
        localStorage.setItem("EnglishUrl", body.data.content);
      });
      // that.all_app_color = color;
      // that.$store.commit("change_EnglishUrl", body.data.content);
      // localStorage.setItem("all_app_color", color);
    },
    get_all_app_color() {
      let that = this;
      fetch(ServiceApi.api + "layout_model/get_select_config", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ type: "color_model" })
      })
        .then(function(response) {
          return response.json();
        })
        .then(function(myJson) {
          // let color = "";
          // if (myJson.data.label == "YSMB00001") {
          //   color = "#5DBC8D";
          // } else if (myJson.data.label == "YSMB00002") {
          //   color = "#9BCB49";
          // } else if (myJson.data.label == "YSMB00003") {
          //   color = "#20ADFF";
          // } else if (myJson.data.label == "YSMB00004") {
          //   color = "#660CB3";
          // } else if (myJson.data.label == "YSMB00005") {
          //   color = "#CC1F34";
          // } else if (myJson.data.label == "YSMB00006") {
          //   color = "#F7B32A";
          // } else if (myJson.data.label == "YSMB00007") {
          //   color = "#F06834";
          // } else if (myJson.data.label == "YSMB00008") {
          //   color = "#8B572A";
          // } else if (myJson.data.label == "YSMB00009") {
          //   color = "#303030";
          // }
          // that.all_app_color = color;
          // that.$store.commit("change_all_color", color);
          // localStorage.setItem("all_app_color", color);

          that.all_app_color = myJson.data.title;
          that.$store.commit("change_all_color", that.all_app_color);
          localStorage.setItem("all_app_color", that.all_app_color);
          document.documentElement.style.setProperty(
            "--colorr",
            `${that.all_app_color}`
          );
        });
    }
    // reload() {
    //   this.isRload = false;
    //   this.$nextTick(function() {
    //     this.isRload = true;
    //   });
    // }
  },
  beforeCreate() {},
  created() {
    // document.documentElement.style.setProperty("--set_font_colorS", "red");
    // document.documentElement.style.setProperty("--set_font_sizeS", "20px");
    // 德彪钢笔行书
    //  $youziku.load("body", "e1ccb2a5a25448699c382b345a7e4c5b", "LiDeBiao-Xing3");

    // 思源黑体Light
    // $youziku.load(
    //   "body",
    //   "63d1baa410724025979a91aee5500d08",
    //   "Source-Han-Light"
    // );
    // 思源黑体Normal
    //  $youziku.load("body", "d2be3504e19c4cceb526eb07782acdae", "Source-Han-Normal");
    //  思源黑体ExtraLight
    //  $youziku.load("body", "48677cae8ee0491ab61bd30b120165bf", "SiYuan-ExtraLight");
    //  思源黑体Regular
    //  $youziku.load("body", "501804eb41c74258bcfbb3f36d1df3e1", "SiYuanRegular");

    // 经典中圆简
    //  $youziku.load("body", "f7e79a809e5d4ab88ed5e1772a032123", "jdzhonyuanjian");

    // 田氏宋体旧字形
    // $youziku.load("body", "0791a9ccb8cc48e49013cab24abd73c2", "TSSunOld");

    // 幼圆
    // $youziku.load("body", "72d9bc68a25f4fc8bc2c7d47a40fe65c", "YouYuan");
    // 创艺简行楷
    //  $youziku.load("body", "dbdd9724ec9b479f8ae49c3d1d6b1375", "cyjianxk");
    // $youziku.draw();

    // let body_dom = documentElement
    // this.all_app_color = localStorage.getItem("all_app_color"); //将本地的全局配色，赋值给 this.all_app_color
    this.get_color_style(); // if (!localStorage.getItem("all_app_color")) {
    this.get_font_size_style(); // if (!localStorage.getItem("all_app_color")) {
    this.get_font_style(); // if (!localStorage.getItem("all_app_color")) {
    this.get_all_app_color();

    this.get_by_id_lang_link();
    // }
    if (!this.$store.state.role) {
      let role = sessionStorage.getItem("role");
      let role_name = sessionStorage.getItem("role_name");
      let head = sessionStorage.getItem("head");
      let data = {};
      data.role = role;
      data.role_name = role_name;
      data.head = head;
      this.$store.commit("islogintrueclick", data);
    }
    //     islogintrueclick(state,data){             //登录完成后将用户名和相关通用的标识给全局保存，（用来确认要不要显示顶部的编辑按钮）
    //   state.role=data.role;
    //   state.role_name=data.role_name;
    //   state.head=data.head;
    // },
    // let site = localStorage.getItem("site");
  },
  mounted() {
    // this.$refs.loader_wrapper.style.display='none';
  }
};
</script>

<style>
/* @font-face {
    font-family:"huawenkaiti"; 
    src: url('./assets/font/huawenkaiti.ttf'); 
  }
 @font-face {
    font-family:"huawensongti"; 
    src: url('./assets/font/huawenkaiti.ttf'); 
  }
 @font-face {
    font-family:"huawenxihei"; 
    src: url('./assets/font/huawenxihei.ttf'); 
  }
 @font-face {
    font-family:"huawenxingkai"; 
    src: url('./assets/font/huawenxingkai.ttf'); 
  }
 @font-face {
    font-family:"huawenxinwei"; 
    src: url('./assets/font/huawenxinwei.ttf'); 
  }
 @font-face {
    font-family:"huawenzhongsong"; 
    src: url('./assets/font/huawenzhongsong.ttf'); 
  }
 @font-face {
    font-family:"yuanyou"; 
    src: url('./assets/font/yuanyou.ttf'); 
  }

 @font-face {
    font-family:"heiti"; 
    src: url('./assets/font/heiti.ttf'); 
  }
 @font-face {
    font-family:"fangsong"; 
    src: url('./assets/font/fangsong.ttf'); 
  }

 @font-face {
    font-family:"fangzhengshuti"; 
    src: url('./assets/font/fangzhengshuti.ttf'); 
  }

.fangzhengshuti {
  font-family: "fangzhengshuti" !important;
}
.fangsong {
  font-family: "fangsong" !important;
}
.heiti {
  font-family: "heiti" !important;
}
.huawenkaiti {
  font-family: "huawenkaiti" !important;
}
.huawensongti {
  font-family: "huawensongti" !important;
}
.huawenxihei {
  font-family: "huawenxihei" !important;
}
.huawenxingkai {
  font-family: "huawenxingkai" !important;
}
.huawenxinwei {
  font-family: "huawenxinwei" !important;
}
.huawenzhongsong {
  font-family: "huawenzhongsong" !important;
} */

/* .yuanyou {
  font-family: "yuanyou" !important;
} */

/* font-family: 'SimSun', 'Microsoft YaHei', Arial, Verdana, "\5b8b\4f53", myanmar, Zawgyi-One ; */
/* font-family: "Noto Serif", "Noto Serif CJK SC", "Noto Serif CJK",
    "Source Han Serif SC", ‘ Source Han Serif ’, source-han-serif-sc, serif; */

.songti {
  font-family: "宋体", Arial, Verdana, "Microsoft YaHei", "Noto Serif",
    "Noto Serif CJK SC", "Noto Serif CJK", "Source Han Serif SC", "sans-serif" !important;
}
.microsoft_yahei {
  font-family: "Microsoft YaHei", Arial, Verdana, "宋体", "Noto Serif",
    "Noto Serif CJK SC", "Noto Serif CJK", "Source Han Serif SC", "sans-serif" !important;
}
.huawenxihei {
  font-family: "华文细黑", Arial, Verdana, "Microsoft YaHei", "Noto Serif",
    "Noto Serif CJK SC", "Noto Serif CJK", "Source Han Serif SC", "sans-serif" !important;
}
.heiti {
  font-family: "黑体", Arial, Verdana, "Microsoft YaHei", "Noto Serif",
    "Noto Serif CJK SC", "Noto Serif CJK", "Source Han Serif SC", "sans-serif" !important;
}
.Noto_Serif {
  font-family: "Noto Serif", Arial, Verdana, "Noto Serif CJK SC",
    "Noto Serif CJK", "Source Han Serif SC", ‘ Source Han Serif ’,
    source-han-serif-sc, serif !important;
}
.Comic_Sans_MS {
  font-family: "Comic Sans MS", Arial, "Microsoft YaHei", Verdana, "Noto Serif",
    "Noto Serif CJK SC", "Noto Serif CJK", "Source Han Serif SC", "sans-serif" !important;
}
.Helvetica {
  font-family: "Helvetica", Arial, Verdana, "Microsoft YaHei", "Noto Serif",
    "Noto Serif CJK SC", "Noto Serif CJK", "Source Han Serif SC", "sans-serif" !important;
}
.Arial {
  font-family: Arial, Verdana, "Microsoft YaHei", "Noto Serif",
    "Noto Serif CJK SC", "Noto Serif CJK", "Source Han Serif SC", "sans-serif" !important;
}
.Lucida {
  font-family: "Lucida", Arial, Verdana, "Microsoft YaHei", "Noto Serif",
    "Noto Serif CJK SC", "Noto Serif CJK", "Source Han Serif SC", "sans-serif" !important;
}
.Verdana {
  font-family: "Verdana", Arial, "Microsoft YaHei", "Noto Serif",
    "Noto Serif CJK SC", "Noto Serif CJK", "Source Han Serif SC", "sans-serif" !important;
}
.Lucida_Grande {
  font-family: "Lucida Grande", Arial, Verdana, "Noto Serif",
    "Noto Serif CJK SC", "Noto Serif CJK", "Source Han Serif SC", "sans-serif" !important;
}

:root {
  --color: var(--colorr);
}
:root {
  --set_font_size: var(--set_font_sizeS);
}
.calss_set_font_size {
  font-size: 16px;
  font-size: var(--set_font_size);
}
:root {
  --set_font_color: var(--set_font_colorS);
}
body .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--color);
  color: #fff;
}
body .all_app_color {
  color: var(--color);
}
body .el-input.is-active .el-input__inner,
body .el-input__inner:focus {
  border-color: var(--color);
  outline: 0;
}
body .el-select .el-input.is-focus .el-input__inner {
  border-color: var(--color);
}
body .el-select-dropdown__item.selected {
  color: var(--color);
}
body .el_cancel:hover {
  color: var(--color);
  border-color: var(--color);
  background-color: #ffffff;
}
body .el-breadcrumb__inner a:hover,
.el-breadcrumb__inner.is-link:hover {
  color: var(--color);
}
body .el-button--primary {
  color: #fff;
  background-color: #66b1ff;
  background-color: var(--color);
  border-color: var(--color);
}
body .el-button--primary:focus,
body .el-button--primary:hover {
  background: var(--color);
  border-color: var(--color);
  color: #fff;
  opacity: 0.8;
}
body .el-button:active {
  color: var(--color);
  border-color: var(--color);
  outline: 0;
  background-color: #ffffff;
}
body .el-button:focus,
body .el-button:hover {
  color: var(--color);
  border-color: var(--color);
  background-color: #ffffff;
  opacity: 0.8;
}

.top .el-breadcrumb {
  font-size: 14px !important;
  line-height: 14px !important;
}
.el_breadcrumb_home {
  display: -webkit-box;
  -webkit-box-align: center;
  display: flex;
  align-items: center;
}
.el_breadcrumb_item {
  height: 17px;
  line-height: 17px;
  display: block;
}
.button_CX {
  background-color: #76bbdd;
}
/* .icon-xiugai {
  color: #3b9dce;
} */
@import "./assets/css/main.css";
@import "./assets/css/color-dark.css"; /*  深色主题 */
/*@import "./assets/css/theme-green/color-green.css"; 浅绿色主题*/
.el-header {
  padding: 0px !important;
}
.el-footer {
  padding: 0px !important;
}
/* #app {
  overflow: auto;
} */
.el-main {
  padding: 0px !important;
  /* min-width: 1300px; */
  background: #ffffff;
}
/* .container {
  min-width: 1300px;
} */
@media (min-width: 992px) and (max-width: 1199px) {
  .el-main {
    min-width: 992px;
  }
  .container {
    min-width: 992px;
  }
}
/*在768 和991 像素之间的屏幕里，小屏幕，主要是PAD*/
@media (min-width: 768px) and (max-width: 991px) {
  .el-main {
    min-width: 768px;
  }
  .container {
    min-width: 768px;
  }
}
/*在480 和767 像素之间的屏幕里，超小屏幕，主要是手机*/
@media (min-width: 480px) and (max-width: 767px) {
  .el-main {
    min-width: 480px;
  }
  .container {
    min-width: 480px;
  }
}
/*在小于480px的屏幕里，微小屏幕，更低分辨率的手机*/
@media (max-width: 479px) {
  .el-main {
    width: 100%;
    overflow-x: hidden;
  }
  .container {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue